import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

export default {
    async list(param: types.ReqParam): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/faq/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detail(idx: number): Promise<types.ResFaq> {
        const res = {} as types.ResFaq;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/faq/detail/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async add(param: types.ReqFaq): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/faq/add", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(param: types.ReqFaqForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/faq/modify", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/faq/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async removeForFile(idx: number, idxFile: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/faq/remove/" + idx + "/" + idxFile, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
